import React, { useState } from "react";
import {
  Button,
  Divider,
  Modal,
  TableAdv,
} from "../../../../../components";
import { formatWords2 } from "../../../../../utils/stringUtils";

const ViewLeadModal = ({ data, onEdit, onDelete }) => {
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);

  function getSiteName(url) {
    try {
      const { hostname } = new URL(url);
      let name = hostname
        .replace(/^www\./, "")
        .split(".")[0]
        .replace(/-/g, " ");
      name = name.charAt(0).toUpperCase() + name.slice(1);
      return name;
    } catch {
      return "Link";
    }
  }
  const columns = [
    {
      key: "companyName",
      label: "Account Name",
      width: "w-40",
      columnMenu: false,
     render: (row) => (
     <div className="flex flex-col gap-2 text-sm">
      <div>
      
        <div className="font-semibold">
          {formatWords2(row?.companyName || "-")}
        </div>
      </div>

      <div>
        
        {row?.website ? (
          <a
            href={row.website}
            target="_blank"
            rel="noreferrer"
            className="text-blue-600 hover:underline break-all"
          >
            {row.website}
          </a>
        ) : (
          "-"
        )}
      </div>
    </div>
),
    },
    {
      key: "jobTitle",
      label: "Job Details",
      width: "w-60",
      columnMenu: false,
      render: (row) => {
        return (
          <div className="flex flex-col gap-2 text-sm">
             <div>
     
        <div className="font-medium">
          {formatWords2(row?.jobTitle || "-")}
        </div>
      </div>

      <div>
      
        {row?.jobDescription ? (
          <a
            href={row.jobDescription}
            target="_blank"
            rel="noreferrer"
            className="text-blue-600 hover:underline break-all"
          >
            {getSiteName(row.jobDescription)}
          </a>
        ) : (
          "-"
        )}
      </div>


      <div>
      
        <div className="text-gray-700">
          {row?.jobLocation || "-"}
        </div>
      </div>

    </div>
        );
      },
    },
    {
      key: "contactDetails",
      label: "Contact Details",
      columnMenu: false,
      render: (row) => {
        return (
          <div className="flex flex-col gap-2">
            {row?.contactDetails.length > 0 ? (
              row?.contactDetails.map((item, index) => (
               <React.Fragment key={index}>
          {index === 0 && (
            <div className="grid grid-cols-4 gap-4 text-xs font-semibold text-gray-500">
              <div>Name</div>
              <div>Email</div>
              <div>Phone</div>
              <div>Location</div>
            </div>
          )}

          <div className="grid grid-cols-4 gap-4 text-sm">
  <div>
    <div className="font-medium">{formatWords2(item?.name || "-")}</div>
    <div className="text-xs text-gray-500">
      {formatWords2(item?.designation || "-")}
    </div>
  </div>

  <div className="truncate">
    {typeof item?.email === "string"
      ? item.email
      : item?.email?.email || "-"}
  </div>

  <div>{item?.phone || "-"}</div>
  <div className="truncate">{formatWords2(item?.location || "-")}</div>
</div>

          {index !== row.contactDetails.length - 1 && <Divider />}
        </React.Fragment>
              ))
            ) : (
              <div>No contact details available</div>
            )}
          </div>
        );
      },
    },
    {
      key: "",
      label: "Actions",
      width: "w-24",
      render: () => (
        <div className="flex items-center justify-center gap-2">
          <Button
            type="icon"
            variant="text"
            icon="edit_square"
            size="xs"
            color="black"
            onClick={onEdit}
          />
          <Button
            type="icon"
            variant="text"
            icon="delete"
            size="xs"
            color="black"
            onClick={() => {
              // setShowDeleteAlert(true);
              onDelete?.(data?.companyId, data?.companyName);
            }}
          />
        </div>
      ),
    },
  ];

  // const rows = data && {
  //   companyName: data.companyName,
  //   jobTitle: data.jobTitle,
  //   contactDetails: data.contactDetails,
  //   jobLocation: data.jobLocation,
  // };
  const rows = {
    companyName: formatWords2(data?.companyName) || "-",
    jobTitle: data?.jobTitle || "-",
    contactDetails: Array.isArray(data?.contactDetails)
      ? data.contactDetails
      : [],
    jobLocation: data?.jobLocation || "-",
    jobDescription: data?.jobDescription || "",
    companyId: data?.companyId,
    website: data?.website,
  };

  return (
    <div className="p-0 h-full max-h-[70vh] overflow-hidden">
      <TableAdv
        columns={columns}
        rows={[rows]}
        hideToolBar
        tableId={"viewLeadModal"}
      />

      {/* <Alert
        isOpen={showDeleteAlert}
        onClose={() => setShowDeleteAlert(false)}
        title="Delete Item"
        description={
          <div className="text-center">
            Are you sure you want to delete{" "}
            <p className="text-info">"{data.companyName}"</p> from the Companies
            list?
          </div>
        }
        cancelButton={{
          show: true,
          title: "Cancel",
          onClick: () => console.log("Cancelled"),
        }}
        acceptButton={{
          show: true,
          title: "Delete",
          onClick: () => console.log("Delete"),
        }}
      /> */}
      <Modal
        showCloseButton={false}
        isOpen={showDeleteAlert}
        onClose={() => setShowDeleteAlert(false)}
      >
        <div className="text-center my-3">
          <p>Are you sure you want to delete</p>
          <p className="text-info">"{data?.companyName}"</p>
          <p>from my Companies list?</p>
          <div className="flex justify-center items-center gap-3 mt-8">
            <Button
              title="Cancel"
              variant="outlined"
              color="black"
              onClick={() => {
                setShowDeleteAlert(false);
              }}
            />
            <Button
              title="Delete"
              onClick={() => {
                onDelete?.(data?.companyId);
                setShowDeleteAlert(false);
              }}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ViewLeadModal;
